import { AxiosResponse } from "axios";
import { microserviceApiRoutes } from "../../microservice-api.routes";
import { microserviceApiAxios } from "../../microservice-api.axios";
import {
  GetStatusPurchaseAgentRes,
  PurchaseAgentReq,
  PurchaseAgentRes,
} from "./purchase-agents-service.interface";

export const createPurchaseAgentsService = (data: PurchaseAgentReq) => {
  const url = microserviceApiRoutes.v1.agents.policy.purchaseRecurrent();
  return microserviceApiAxios
    .post<Error, AxiosResponse<PurchaseAgentRes>>(url, data)
    .then((res) => res.data);
};

export const getStatusPurchaseAgentService = (sessionTransaction: string) => {
  const url =
    microserviceApiRoutes.v1.agents.policy.getStatusPurchaseAgent(
      sessionTransaction,
    );
  return microserviceApiAxios
    .get<Error, AxiosResponse<GetStatusPurchaseAgentRes>>(url)
    .then((res) => res.data);
};
